export enum RewardTriggerTypeEnum {
  EASTER_EGGS = 'easterEggs',
  LEVEL = 'on-level-up',
  RANK = 'on-rank-up',
  MISSION = 'on-missions-complete',
}
